const DEFAULT_API_BASE_URL = 'http://localhost:5000/api';

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

const envApiBaseUrl = process.env.REACT_APP_API_URL?.trim();

export const API_BASE_URL = trimTrailingSlash(envApiBaseUrl || DEFAULT_API_BASE_URL);
